import { ActivityDepositConditionType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

export const activityDepositConditionTypeName: { [key in ActivityDepositConditionType]: TKeyType } = {
  [ActivityDepositConditionType.SINGLE]: 'common.singleDeposit',
  [ActivityDepositConditionType.ACCUMULATED]: 'common.accumulatedDeposit'
}

export default activityDepositConditionTypeName
